export default "__VITE_ASSET__CEX9QUZO__"